// Worker-facing copy for document flags + reviewReason codes + the in-review acknowledge dialog.
// Separate from the admin documents.json (different audience/tone) and from the large
// socSecuritySectionTranslations.js. Does its OWN English fallback merge, because
// getTextDefaults() in the soc-sec translations does not merge EN per-key.
const EN = {
	acknowledge: {
		title: 'Why is this document flagged?',
		// Statement headline for the expanded (guided-capture) panel; `title` stays for the legacy collapsible.
		reviewTitle: 'We couldn\'t verify this document',
		explainer:
			'We could not fully verify this document. You can continue, but your submission will stay pending manual review and will not grant access until it has been reviewed.',
		cancel: 'Upload a different file',
		proceed: 'Continue anyway',
		acknowledged: 'You chose to continue, this document stays pending review.',
	},
	fallback: { label: 'Verification issue', description: 'We could not fully verify this document.' },
	flags: {
		EXPIRED: { label: 'Expired', description: 'The document\'s validity date has passed.' },
		TYPE_MISMATCH: { label: 'Wrong document type', description: 'This is not one of the requested document types.' },
		NAME_MISMATCH: { label: 'Name mismatch', description: 'The name on the document does not match the name provided.' },
		DOB_MISMATCH: { label: 'Date of birth mismatch', description: 'The date of birth on the document does not match the one provided.' },
		FORGERY_SUSPECTED: { label: 'Could not confirm authenticity', description: 'We could not confirm this document is authentic.' },
		MISSING_REQUIRED_FIELDS: { label: 'Missing information', description: 'Some required fields are missing from the document.' },
		INCOMPLETE_DOCUMENT: { label: 'Incomplete document', description: 'The document appears incomplete; pages may be missing.' },
		MISSING_FRONT_SIDE: { label: 'Front side missing', description: 'The front of your document is missing. Please add a clear photo of the front side.' },
		MISSING_BACK_SIDE: { label: 'Back side missing', description: 'The back of your document is missing. Please add a clear photo of the back side.' },
		CDR_MISMATCH: { label: 'CDR mismatch', description: 'The diploma was found in the CDR registry but some details differ.' },
		CDR_NOT_FOUND: { label: 'Not found in CDR', description: 'The diploma number was not found in the CDR registry.' },
		LIMOSA_MISMATCH: { label: 'Limosa mismatch', description: 'The Limosa details do not match the document.' },
		LIMOSA_NOT_FOUND: { label: 'Limosa not verified', description: 'The Limosa QR code could not be verified.' },
		COMPANY_INFO_MISMATCH: { label: 'Company details mismatch', description: 'Company name or address differs from the provided data.' },
		EXTERNAL_VERIFICATION_FAILED: { label: 'External check failed', description: 'An automated check against an external registry was inconclusive.' },
		MISSING_STAMP_OR_SIGNATURE: { label: 'Missing stamp/signature', description: 'An expected stamp or signature is missing.' },
		BLURRY: { label: 'Image too blurry', description: 'The image quality is too low to read reliably.' },
		ENCRYPTED: { label: 'Password-protected', description: 'The PDF is password-protected and could not be read.' },
		BLANK_DOCUMENT: { label: 'Blank document', description: 'No readable text or images were found.' },
		TOO_MANY_PAGES: { label: 'Too many pages', description: 'The document has more pages than allowed.' },
		// CDR_VERIFIED / LIMOSA_VERIFIED are positive → intentionally omitted (problems-only)
	},
	reviewReasons: {
		UNSUPPORTED_CLASS: { label: 'Could not read document', description: 'Upload the front side of the requested document, clearly visible.' },
		DETECTION_FAILED: { label: 'Document not detected', description: 'No document was detected. Make sure the whole document is visible and in focus.' },
	},
};

// Add NL/FR/DE objects as they are translated; untranslated keys fall back to EN.
const LANGUAGES = { EN };

export function getFlagMessages(lang) {
	const base = LANGUAGES[(lang || 'EN').toUpperCase()] || {};
	return {
		acknowledge: { ...EN.acknowledge, ...base.acknowledge },
		fallback: { ...EN.fallback, ...base.fallback },
		flags: { ...EN.flags, ...base.flags },
		reviewReasons: { ...EN.reviewReasons, ...base.reviewReasons },
	};
}
